<template>
  <main class="world-terrain-map-page">
    <iframe
      class="terrain-map-frame"
      title="世界山川地形图"
      src="/static/maps/world-terrain-map.html?v=20260712-2"
      loading="eager"
    ></iframe>
  </main>
</template>

<script>
export default {
  name: 'world-terrain-map'
}
</script>

<style scoped>
.world-terrain-map-page {
  width: 100%;
  min-height: calc(100vh - 90px);
  background: #f4efe4;
}

.terrain-map-frame {
  display: block;
  width: 100%;
  height: calc(100vh - 90px);
  min-height: 680px;
  border: 0;
  background: #f4efe4;
}

@media (max-width: 800px) {
  .world-terrain-map-page {
    min-height: calc(100vh - 72px);
  }

  .terrain-map-frame {
    height: calc(100vh - 72px);
    min-height: 560px;
  }
}
</style>
